import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'requiredQuantity',
  standalone: false
})
export class RequiredQuantityPipe implements PipeTransform {
  transform(value: string): string {
    return RequiredQuantityPipe.format(value);
  }

  static format(value: string): string {
    if (value) {
      switch (value) {
        case "PILOT_DETERMINES":
          return "L.A.B.";
        case "ONE":
          return "1";
        case "TWO":
          return "2";
        case "THREE":
          return "3";
        case "FOUR":
          return "4";
        case "FIVE":
          return "5";
        case "SIX":
          return "6";
        case "SEVEN":
          return "7";
        case "EIGHT":
          return "8";
        case "NINE":
          return "9";
        default:
          throw Error('Unknown RequiredQuantity value: ' + value);
      }
    }
  }
}